import { useRef } from "react";
import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonItem,
  IonList,
  IonModal,
  IonRadio,
  IonRadioGroup,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { Asterisk, Colors, Icon } from "swing-components";

import { translate } from "~utils";

type TimeToAcceptProps = {
  value: number | string;
  choices: (number | string)[];
  onChange: (v: number | string) => void;
};

export function TimeToAccept(props: TimeToAcceptProps) {
  const { value, choices, onChange } = props;
  return (
    <div>
      <div
        css={{
          width: "100%",
          display: "flex",
          alignItems: "center",
        }}
      >
        <div>
          <>
            <p css={{ margin: 0, display: "inline-block", fontWeight: 500 }}>
              {translate("TIME_TO_ACCEPT_LABEL")}
            </p>
            <Asterisk />
          </>
          <p css={{ margin: 0 }}>
            {typeof value === "number"
              ? translate("TIME_TO_ACCEPT_VALUE", { hours: value })
              : translate("TIME_TO_ACCEPT_ONLY_SELECTED_SUBS_VALUE")}
          </p>
        </div>
        <div
          id="modal"
          css={{
            display: "flex",
            justifyContent: "end",
            cursor: "pointer",
            flex: "1 1 0%",
          }}
        >
          <div
            css={{
              display: "flex",
              gap: 4,
              alignItems: "center",
            }}
          >
            <Icon name="Chevron Down" />
          </div>
        </div>
      </div>
      <TimeToAcceptModal trigger="modal" value={value} choices={choices} onChange={onChange} />
    </div>
  );
}

type TimeToAcceptModalProps = TimeToAcceptProps & {
  trigger: string;
};

function TimeToAcceptModal(props: TimeToAcceptModalProps) {
  const { trigger, value, choices, onChange } = props;
  const modal = useRef<HTMLIonModalElement>(null);
  const onModalClose = () => {
    modal.current?.dismiss();
  };

  return (
    <IonModal trigger={trigger} ref={modal} backdropDismiss>
      <IonHeader css={{ boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.15)" }}>
        <IonToolbar>
          <IonTitle>{translate("TIME_TO_ACCEPT_MODAL_HEADER")}</IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={onModalClose} strong>
              {translate("LABEL_CLOSE")}
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonList css={{ backgroundColor: Colors.white200, padding: "16px 0" }}>
          <IonRadioGroup value={value} onIonChange={(e) => onChange(e.target.value)}>
            {choices.map((timeChoice, idx) => (
              <IonItem key={idx}>
                <IonRadio value={timeChoice} justify="start" labelPlacement="end">
                  {typeof timeChoice === "number"
                    ? translate("TIME_TO_ACCEPT_VALUE", { hours: timeChoice })
                    : translate("TIME_TO_ACCEPT_ONLY_SELECTED_SUBS_VALUE")}
                </IonRadio>
              </IonItem>
            ))}
          </IonRadioGroup>
        </IonList>
      </IonContent>
    </IonModal>
  );
}
